import React from "react";
import MagicalCard from "./MagicalCard";
import { Icon } from "./common";
import { useLang } from "../i18n";

export default function EarnPointsPanel({ categories = [] }) {
  const { t, pick } = useLang();
  return (
    <MagicalCard title={t("dash.how_to_earn")} variant="ribbon-pink" testId="earn-points-panel">
      <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-3">
        {categories.map((c) => (
          <div key={c.key} data-testid={`earn-category-${c.key}`}
            className="rounded-2xl p-4 text-center border transition-transform duration-300 hover:-translate-y-1"
            style={{ background: `linear-gradient(165deg, ${c.color}30, ${c.color}0D)`, borderColor: `${c.color}55` }}>
            <div className="w-12 h-12 mx-auto rounded-2xl flex items-center justify-center mb-2"
              style={{ background: `linear-gradient(135deg, ${c.color}, ${c.color}AA)`, boxShadow: `0 0 14px ${c.color}66` }}>
              <Icon name={c.icon} className="w-6 h-6 text-white" />
            </div>
            <p className="text-xs sm:text-sm font-extrabold leading-snug min-h-[2.2em] flex items-center justify-center">{pick(c, "name")}</p>
            <p className="text-2xl font-black mt-1" style={{ color: c.color }} dir="ltr">{c.default_points > 0 ? `+${c.default_points}` : c.default_points}</p>
          </div>
        ))}
      </div>
      <p className="text-center text-sm text-[#D8D4F2] font-bold mt-5 flex items-center justify-center gap-2">
        <span className="text-[#FFC83D]">✦</span> {t("dash.every_point")} <span className="text-[#FFC83D]">✦</span>
      </p>
    </MagicalCard>
  );
}
